module.exports = __webpack_public_path__ + "static/img/t1.79fa1ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/t1.jpg
// module id = kNBw
// module chunks = 1